import { Checkbox as Primitive } from "@/design-system/primitives/checkbox";
import { cn } from "@/design-system/cn.ts";

/**
 * The console's checkbox: the vendored primitive at this app's size and colour.
 *
 * **The tick is scaled with the box.** The primitive draws a fixed 14px glyph,
 * sized for its own 16px square — and every box in this app is smaller than
 * that, so the tick was running out to the rounded corners and past them. It
 * read as a check stuck to the edges of a frame rather than one sitting inside
 * it, which is the whole of why a checked box looked wrong. A smaller glyph
 * needs a heavier stroke to hold its weight at this size, hence the override.
 *
 * One place rather than three: the same twelve-class string was pasted at every
 * call site, so the sizes had already drifted apart by a couple of pixels.
 */
export function CheckBox({ className, ...props }: React.ComponentProps<typeof Primitive>) {
  return (
    <Primitive
      className={cn(
        "size-3.5 rounded-[3px] border-rule-bright",
        "data-[state=checked]:border-signal data-[state=checked]:bg-signal data-[state=checked]:text-on-accent",
        "[&_svg]:size-2.5 [&_svg]:[stroke-width:3]",
        className,
      )}
      {...props}
    />
  );
}
